// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectFieldWithError_select_wrap__Uu7Bu {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.selectFieldWithError_select_wrap__Uu7Bu label {
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 5px;
}
.selectFieldWithError_select_wrap__Uu7Bu select {
  height: 50px;
  width: 100%;
  padding: 13px 18px;
  padding-right: 25px;
  border: none;
  outline: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/FormFields/SelectFieldWithError/selectFieldWithError.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;AACE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AACE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AACJ","sourcesContent":[".select_wrap {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n\n  label {\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 700;\n    margin-bottom: 5px;\n  }\n  select {\n    height: 50px;\n    width: 100%;\n    padding: 13px 18px;\n    padding-right: 25px;\n    border: none;\n    outline: none;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 1;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select_wrap": `selectFieldWithError_select_wrap__Uu7Bu`
};
export default ___CSS_LOADER_EXPORT___;
